export const SESSION_EXPIRED_RETURN_PATH_PARAMETER = 'return_path'

/**
 * App-relative path of the route that clears a session Nile-Core rejected and then sends
 * the patient to /login. `returnPath` is the page to come back to after signing in, without
 * origin or basePath. Callers add the basePath (`appPath`) when navigating from the browser.
 */
export function sessionExpiredPath(returnPath?: string): string {
    if (!returnPath) {
        return '/auth/session-expired'
    }
    const searchParams = new URLSearchParams({ [SESSION_EXPIRED_RETURN_PATH_PARAMETER]: returnPath })
    return `/auth/session-expired?${searchParams.toString()}`
}
